import Image from 'next/image';
import no_image from '../public/loading.gif';

export default function Loading() {
    return (
        <div className="h-[90vh] w-full flex justify-center items-center">
            <Image width={75} src={no_image} alt="Loading..."></Image>
            {/* <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-primary border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white" role="status">
                <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Loading...</span>
            </div> */}
        </div>
    )
}
